import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1145c1ee"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "onedesk-component-container onedesk-component-container-inventory" };
const _hoisted_2 = {
    key: 0,
    class: "pi pi-search-plus",
    style: { "color": "var(--cyan-400)" }
};
import { computed, ref, watch } from "vue";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from "primevue/api";
import BrandsMultiSelector from "@/components/molecules/BrandsMultiSelector.vue";
import MarketsMultiSelector from "@/components/molecules/MarketsMultiSelector.vue";
import DivisionsMultiSelector from "@/components/molecules/DivisionsMultiSelector.vue";
import ZonesMultiSelector from "@/components/molecules/ZonesMultiSelector.vue";
import "vue-loading-overlay/dist/css/index.css";
import OneDeskMarketColumn from "@/components/molecules/OneDeskMarketColumn.vue";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'InventoryBrandsAndMarketsTable',
    props: {
        tableData: { default: () => [] },
        columnsDefinition: { default: () => [] },
        hasPagination: { type: Boolean, default: false },
        headerClass: { default: "" },
        groupedValue: { default: "brand" },
        onRowClick: { type: Function, default: () => true },
        pageIndex: { default: 1 },
        pageSize: { default: 10 },
        totalRecords: { default: 0 }
    },
    emits: ["page-change"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const datatable = ref();
        const expandedRows = ref([]);
        const emit = __emit;
        watch(() => props.groupedValue, () => {
            filters.value = {
                displayBrand: { value: null, matchMode: FilterMatchMode.IN },
                displayMarket: { value: null, matchMode: FilterMatchMode.IN },
                division: { value: null, matchMode: FilterMatchMode.IN },
                zone: { value: null, matchMode: FilterMatchMode.IN },
            };
        });
        const filters = ref({
            displayBrand: { value: null, matchMode: FilterMatchMode.IN },
            displayMarket: { value: null, matchMode: FilterMatchMode.IN },
            division: { value: null, matchMode: FilterMatchMode.IN },
            zone: { value: null, matchMode: FilterMatchMode.IN },
        });
        const isOpen = (data) => {
            return expandedRows.value.includes(data);
        };
        const groupedValueComputed = computed(() => {
            return props.groupedValue;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", {
                    ref_key: "datatable",
                    ref: datatable,
                    class: "inventory-table-container"
                }, [
                    _createVNode(_unref(DataTable), {
                        "data-test": "inventory-datatable",
                        expandedRows: expandedRows.value,
                        "onUpdate:expandedRows": _cache[0] || (_cache[0] = ($event) => ((expandedRows).value = $event)),
                        filters: filters.value,
                        "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((filters).value = $event)),
                        value: _ctx.tableData,
                        paginator: _ctx.hasPagination,
                        rows: _ctx.pageSize,
                        lazy: "",
                        "row-class": () => 'one-desk-table-row',
                        totalRecords: _ctx.totalRecords,
                        "responsive-layout": "scroll",
                        "removable-sort": "",
                        first: (_ctx.pageIndex - 1) * _ctx.pageSize,
                        "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                        "sort-order": 1,
                        "sort-field": groupedValueComputed.value,
                        "filter-display": "menu",
                        onRowClick: _ctx.onRowClick,
                        currentPageReportTemplate: "{first} to {last} of {totalRecords}",
                        onPage: _cache[2] || (_cache[2] = ($event) => emit('page-change', $event.page))
                    }, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnsDefinition, (item) => {
                                return (_openBlock(), _createBlock(_unref(Column), {
                                    key: item.field,
                                    field: item.field,
                                    header: item.header,
                                    style: _normalizeStyle(item.field != _ctx.groupedValue ? { width: '200px' } : ''),
                                    "header-class": 'inventory-table-header ' + _ctx.headerClass,
                                    sortable: item.sortable,
                                    "show-filter-menu": false,
                                    showFilterMatchModes: false
                                }, _createSlots({ _: 2 }, [
                                    (item.hasSlot)
                                        ? {
                                            name: "body",
                                            fn: _withCtx((slotProps) => [
                                                _renderSlot(_ctx.$slots, item.field, {
                                                    item: slotProps.data[item.field]
                                                })
                                            ]),
                                            key: "0"
                                        }
                                        : (item.field == 'market')
                                            ? {
                                                name: "body",
                                                fn: _withCtx((slotProps) => [
                                                    _createVNode(OneDeskMarketColumn, {
                                                        "market-code": slotProps.data.market
                                                    }, null, 8, ["market-code"])
                                                ]),
                                                key: "1"
                                            }
                                            : (item.field == 'brand')
                                                ? {
                                                    name: "body",
                                                    fn: _withCtx((slotProps) => [
                                                        _createElementVNode("div", { class: "inventory-table-brand-logo-col" }, [
                                                            _createVNode(ImageWithNoImageDefault, {
                                                                source: slotProps.data.brandPictureUri
                                                            }, null, 8, ["source"]),
                                                            _createElementVNode("span", { style: { "margin-left": "5px" } }, _toDisplayString(slotProps.data.displayBrand), 1)
                                                        ])
                                                    ]),
                                                    key: "2"
                                                }
                                                : undefined,
                                    (item.hasFilter)
                                        ? {
                                            name: "filter",
                                            fn: _withCtx(({ filterModel, filterCallback }) => [
                                                (item.field == 'displayBrand')
                                                    ? (_openBlock(), _createBlock(BrandsMultiSelector, {
                                                        key: 0,
                                                        modelValue: filterModel.value,
                                                        "onUpdate:modelValue": [($event) => ((filterModel.value) = $event), ($event) => (filterCallback())],
                                                        placeholder: "Filter by brands",
                                                        filter: true,
                                                        "option-is-value": true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                    : _createCommentVNode("", true),
                                                (item.field == 'displayMarket')
                                                    ? (_openBlock(), _createBlock(MarketsMultiSelector, {
                                                        key: 1,
                                                        modelValue: filterModel.value,
                                                        "onUpdate:modelValue": [($event) => ((filterModel.value) = $event), ($event) => (filterCallback())],
                                                        placeholder: "Filter by markets",
                                                        filter: true,
                                                        "option-is-value": true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                    : _createCommentVNode("", true),
                                                (item.field == 'zone')
                                                    ? (_openBlock(), _createBlock(ZonesMultiSelector, {
                                                        key: 2,
                                                        modelValue: filterModel.value,
                                                        "onUpdate:modelValue": [($event) => ((filterModel.value) = $event), ($event) => (filterCallback())],
                                                        class: "division-zone-filter",
                                                        placeholder: "Filter by zones",
                                                        filter: true,
                                                        "option-is-value": true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                    : _createCommentVNode("", true),
                                                (item.field == 'division')
                                                    ? (_openBlock(), _createBlock(DivisionsMultiSelector, {
                                                        key: 3,
                                                        modelValue: filterModel.value,
                                                        "onUpdate:modelValue": [($event) => ((filterModel.value) = $event), ($event) => (filterCallback())],
                                                        class: "division-zone-filter",
                                                        placeholder: "Filter by divisions",
                                                        filter: true,
                                                        "option-is-value": true
                                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            key: "3"
                                        }
                                        : undefined
                                ]), 1032, ["field", "header", "style", "header-class", "sortable"]));
                            }), 128)),
                            _createVNode(_unref(Column), {
                                style: { width: '50px' },
                                "header-class": 'inventory-table-header ' + _ctx.headerClass
                            }, {
                                body: _withCtx((slotProps) => [
                                    (!isOpen(slotProps.data))
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_2))
                                        : _createCommentVNode("", true)
                                ]),
                                _: 1
                            }, 8, ["header-class"])
                        ]),
                        _: 3
                    }, 8, ["expandedRows", "filters", "value", "paginator", "rows", "totalRecords", "first", "sort-field", "onRowClick"])
                ], 512)
            ]));
        };
    }
});
